import { createContext, useEffect, useState } from 'react';
import { getSession, useSession } from 'next-auth/react';
import _ from 'lodash';
import logger from '../utils/logger';

//US national level view
const DEFAULT_USER_MAP_OPTIONS = {
  latitude: 39.5,
  longitude: -98,
  zoom: 3,
};

type UserContextProviderProps = {
  children: any;
  apiUrl: string;
};

const userContext = createContext(null);

const isInRole = (tokenParsed: any, tenant: any, role: any) => {
  const tenantResource = tokenParsed.resource_access[tenant];
  if (!tenantResource) return false;
  const tenantRoles = tenantResource.roles;
  if (!tenantRoles && role !== null) return false;
  return tenantRoles.includes(role);
};

const getTenant = (tokenParsed: any, tenantName: any) => {
  const tenants = tokenParsed.resource_access;
  const tenantNames = Object.keys(tenants);
  const accessibleTenantNames = tenantNames.filter((tn) =>
    tenants[tn].roles
      .map((r: string | string[]) => (r.includes('leadcast') ? 1 : 0))
      .includes(1)
  );
  if (typeof tenantName === 'undefined' || tenantName === null) {
    return accessibleTenantNames[0];
  } else {
    if (accessibleTenantNames.includes(tenantName)) {
      return tenantName;
    } else {
      logger.warn('Tenant access denied', {
        tenantName,
        accessibleTenantNames,
      });
      return null;
    }
  }
};

const UserContextProvider: React.FC<UserContextProviderProps> = ({
  children,
  apiUrl,
}) => {
  const { data: session, status }: any = useSession();
  const [state, setState]: any[] = useState({});
  const userInfo: any = session?.userInfo;

  useEffect(() => {
    if (!userInfo?.tokenParsed) {
      setState({});
    } else {
      const tenantName = getTenant(userInfo.tokenParsed, null);
      setState((state: any) => ({
        ...state,
        ...userInfo,
        currentTenantName: tenantName,
      }));
    }
  }, [userInfo]);

  const setTenant = (newTenant: string) => {
    const tenant = getTenant(userInfo.tokenParsed, newTenant);
    if (tenant) {
      setState((state: any) => ({
        ...state,
        currentTenantName: tenant,
      }));
      sessionStorage.setItem('tenantName', newTenant);
    } else {
    }
  };

  const setMapView = (mapView: any) => {
    setState((state: any) => ({
      ...state,
      userMapOptions: mapView,
    }));
  };

  const setValue = {
    ...state,
    setTenant,
    setMapView,
    isInRole: (role: any) =>
      isInRole(userInfo.tokenParsed, state.currentTenantName, role),
  };

  return (
    <userContext.Provider value={setValue}>{children}</userContext.Provider>
  );
};

export { userContext as UserContext, UserContextProvider };
